export const PRODUCTION_ORDER = 'ProductionOrder';
export const ProductionOrderStatusValues = [
    'draft',
    'released',
    'in-progress',
    'completed',
    'cancelled',
];
export const PRODUCTION_ORDER_STATUS_LABELS = {
    draft: 'Rascunho',
    released: 'Liberada',
    'in-progress': 'Em andamento',
    completed: 'Concluída',
    cancelled: 'Cancelada',
};
//# sourceMappingURL=production-order.js.map